import { useState } from 'react'
import { performEnrollment } from '@/lib/enroll'

interface Props {
  onEnrolled: () => void
}

export function EnrollPage({ onEnrolled }: Props) {
  const [code, setCode] = useState('')
  const [label, setLabel] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await performEnrollment(code.trim().toUpperCase(), label.trim() || undefined)
      onEnrolled()
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="screen">
      <form className="card" onSubmit={handleSubmit}>
        <h1>Geraet einrichten</h1>
        <p>Enrollment-Code vom Org-Admin eingeben.</p>
        <input
          className="input"
          placeholder="ENROLLMENT-CODE"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          autoFocus
          required
        />
        <input
          className="input"
          placeholder="Geräte-Name (optional)"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        {error && <p className="error-text">{error}</p>}
        <button className="button button-in" type="submit" disabled={busy || !code}>
          {busy ? 'Wird eingerichtet …' : 'Geraet registrieren'}
        </button>
      </form>
    </div>
  )
}
